import {SessionPhaseType} from "@models";

export enum SimSessionPhasePalette {
	StudentReady = "examPhase-StudentReady",
	PreEncounter = "examPhase-PreEncounter",
	Encounter = "examPhase-Encounter",
	PostEncounter = "examPhase-PostEncounter",
	NonPhase = "examPhase-NonPhase",
}

export const PhaseColorMapping = {
	[SessionPhaseType.StudentReady]: SimSessionPhasePalette.StudentReady,
	[SessionPhaseType.PreEncounter]: SimSessionPhasePalette.PreEncounter,
	[SessionPhaseType.Encounter]: SimSessionPhasePalette.Encounter,
	[SessionPhaseType.PostEncounter]: SimSessionPhasePalette.PostEncounter,
	[SessionPhaseType.Confirmation]: SimSessionPhasePalette.NonPhase,
	[SessionPhaseType.Intermission]: SimSessionPhasePalette.StudentReady,
	[SessionPhaseType.Closing]: SimSessionPhasePalette.NonPhase,
	[-1]: SimSessionPhasePalette.NonPhase,
};
